var map = {
	"./audio-placeholder": 614,
	"./audio-placeholder.png": 614,
	"./avatar-missing": 531,
	"./avatar-missing.png": 531,
	"./avatar-missing.svg": 710,
	"./halloween/clouds": 615,
	"./halloween/clouds.png": 615,
	"./halloween/halloween-emblem": 681,
	"./halloween/halloween-emblem.svg": 681,
	"./halloween/spider": 682,
	"./halloween/spider.svg": 682,
	"./halloween/spiderweb": 683,
	"./halloween/spiderweb.svg": 683,
	"./halloween/starfield": 684,
	"./halloween/starfield.png": 684,
	"./halloween/twinkle": 685,
	"./halloween/twinkle.svg": 685,
	"./header-missing": 535,
	"./header-missing.png": 535,
	"./soapbox-logo": 536,
	"./soapbox-logo-white": 537,
	"./soapbox-logo-white.svg": 537,
	"./soapbox-logo.svg": 536,
	"./sprite-post-functions": 686,
	"./sprite-post-functions.png": 686,
	"./video-placeholder": 687,
	"./video-placeholder.png": 687,
	"./void": 688,
	"./void.png": 688,
	"./web-push/web-push-icon_expand": 689,
	"./web-push/web-push-icon_expand.png": 689,
	"./web-push/web-push-icon_favourite": 690,
	"./web-push/web-push-icon_favourite.png": 690,
	"./web-push/web-push-icon_reblog": 691,
	"./web-push/web-push-icon_reblog.png": 691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;